import React, { Component } from 'react';
import { Drawer, List } from '@material-ui/core';
import { observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../admin/i18n/adminI18n';
import { getSidebarMenuList, getSuperAdminMenuList } from './menuList';
import SidebarMenu from './SidebarMenu'
import "./sidebar.css"
import logo from "../../assets/image/stayplease.png";

// @inject("userStore")
@observer
class Sidebar extends Component {
    render() {
        const { menukey, t } = this.props;
        const adminLoginRole = window.localStorage.getItem('adminLoginRole');

        let menuList = [];

        if (adminLoginRole) {
            if (adminLoginRole !== '') {
                if (adminLoginRole === '"StaymenuSuperadminRole"' || adminLoginRole === '"StayMenuCMSCustomizationModule"') {
                    menuList = getSuperAdminMenuList(t);
                } else if (adminLoginRole === '"StayMenuCMSModule"') {
                    menuList = getSidebarMenuList(t);
                } else {
                    menuList = [];
                }
            }
        }

        return (
            <Drawer variant="permanent" open classes={{ paper: "drawer-permanent" }}>
                <div className="stay-menu-logo-container">
                    <img src={logo} width="90px" alt="StayMenu" />
                </div>
                <List
                    classes={
                        {
                            root: "stay-menu-sidebar-container"
                        }
                    }
                >
                    {
                        menuList.map(menu => {
                            return <SidebarMenu key={menu.key} icon={menu.icon} label={menu.label} redirectUrl={menu.link} subMenu={menu.subMenu} menukey={menukey} />
                        })
                    }
                </List>
            </Drawer>
        );
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(Sidebar);